import { render, staticRenderFns } from "./DeskFilters.vue?vue&type=template&id=45b92af8&scoped=true&"
import script from "./DeskFilters.vue?vue&type=script&lang=js&"
export * from "./DeskFilters.vue?vue&type=script&lang=js&"
import style0 from "./DeskFilters.vue?vue&type=style&index=0&id=45b92af8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b92af8",
  null
  
)

export default component.exports